module.exports = __webpack_public_path__ + "img/type-weixin.bb7a6c57.png";